import User from 'auth/User';
import { AVAILABLE_PAGES_ENUM, PAGES_ENUM, PERMISSION_ENUM } from 'routes/enums';
import { PermissionGroup } from 'utils/user/types';

const getUserPermissionForPage = (user: User, pageName: PAGES_ENUM): PERMISSION_ENUM => {
  if (!user.permissions) {
    return PERMISSION_ENUM.NOT_LOGGED;
  }

  const permissions = user.permissions[pageName];

  try {
    return permissions[0];
  } catch (e) {
    return PERMISSION_ENUM.NOT_LOGGED;
  }
};

const hasLMCPermissions = (user: User): boolean => {
  return getUserPermissionForPage(user, PAGES_ENUM.DASHBOARD) === PERMISSION_ENUM.ADMINISTRATIVE;
};

const hasPermission = (user: User, page: PAGES_ENUM, permission: PERMISSION_ENUM): boolean => {
  return getUserPermissionForPage(user, page) === permission;
};

const createPermissionGroup = (user: User, page: AVAILABLE_PAGES_ENUM, permittedPages: PAGES_ENUM): PermissionGroup => {
  return {
    page,
    permission: getUserPermissionForPage(user, permittedPages),
  };
};

const hasAnyPermission = (user: User, pageName: PAGES_ENUM): boolean => {
  return user.permissions && user.permissions[pageName] ? user.permissions[pageName].length > 0 : false;
};

const exportObject = {
  getUserPermissionForPage,
  hasLMCPermissions,
  hasPermission,
  createPermissionGroup,
  hasAnyPermission,
};

export default exportObject;
